import { render, staticRenderFns } from "./zeroKnowedgeDetail.vue?vue&type=template&id=1d0abce9&scoped=true&"
import script from "./zeroKnowedgeDetail.vue?vue&type=script&lang=js&"
export * from "./zeroKnowedgeDetail.vue?vue&type=script&lang=js&"
import style0 from "./zeroKnowedgeDetail.vue?vue&type=style&index=0&id=1d0abce9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0abce9",
  null
  
)

export default component.exports